export var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus["Unspecified"] = "PROPOSAL_STATUS_UNSPECIFIED";
    ProposalStatus["Deposit"] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    ProposalStatus["Voting"] = "PROPOSAL_STATUS_VOTING_PERIOD";
    ProposalStatus["Passed"] = "PROPOSAL_STATUS_PASSED";
    ProposalStatus["Rejected"] = "PROPOSAL_STATUS_REJECTED";
    ProposalStatus["Failed"] = "PROPOSAL_STATUS_FAILED";
})(ProposalStatus || (ProposalStatus = {}));
export function generateEndpointProposals() {
    return `/cosmos/gov/v1beta1/proposals`;
}
export function generateEndpointProposalTally(proposalId) {
    return `/cosmos/gov/v1beta1/proposals/${proposalId}/tally`;
}
//# sourceMappingURL=gov.js.map